import { waGeneralLink } from "@/lib/whatsapp";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waGeneralLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 w-16 h-16 md:w-[72px] md:h-[72px] rounded-full nb-border bg-[var(--whatsapp)] shadow-[6px_6px_0_0_#0A0A0A] flex items-center justify-center wa-bounce hover:scale-105 transition-transform"
    >
      {/* WhatsApp glyph */}
      <svg viewBox="0 0 32 32" className="w-9 h-9 md:w-10 md:h-10 text-white" fill="currentColor" aria-hidden>
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 01-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 01-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.93 2.722.93.244 0 .448-.036.673-.106.503-.143 1.146-.473 1.247-.993.084-.13.158-.36.158-.516 0-.13.014-.143-.027-.215-.158-.358-2.06-1.224-2.038-1.224z"/>
        <path d="M27.214 4.953A15.39 15.39 0 0016.225 0C7.71 0 .77 6.94.77 15.456c0 2.722.715 5.385 2.077 7.736L0 32l8.984-2.722c2.265 1.232 4.812 1.876 7.4 1.876h.014c8.5 0 15.444-6.94 15.444-15.456-.014-4.124-1.604-8.005-4.628-10.745zm-10.99 23.748h-.013a12.81 12.81 0 01-6.524-1.79l-.473-.272-4.812 1.404 1.275-4.7-.302-.472a12.71 12.71 0 01-1.962-6.812c0-7.062 5.745-12.808 12.812-12.808 3.42 0 6.638 1.347 9.058 3.78a12.74 12.74 0 013.752 9.045c0 7.062-5.745 12.823-12.812 12.823z"/>
      </svg>
    </a>
  );
}
